import { msg } from "@lit/localize";

export interface NavItem {
  title: string;
  url: string;
  icon: string;
  badge?: string | number;
}

/**
 * Primary navigation items with localized titles. Returns fresh `msg()`
 * results each time it's called, so the nav re-renders correctly when the
 * locale changes. Call this at render time (not module scope).
 */
export function getPrimaryNav(): NavItem[] {
  return [
    {
      title: msg("Home"),
      url: "/sprint-dashboard",
      icon: "house",
    },
    { title: msg("My Tasks"), url: "/my-tasks", icon: "list-checks" },
    { title: msg("Apps"), url: "/apps", icon: "folder-kanban" },
    { title: msg("Inbox"), url: "/inbox", icon: "inbox" },
    { title: msg("Members"), url: "/members", icon: "users" },
  ];
}

/**
 * The "Release management" sidebar group: the workspace's release cycles
 * (R1S1, R1S2, ... shared by every project), plus releases, deployments and
 * approvals across all apps. Badges are filled in by nav-list.
 */
export function getReleaseNav(): NavItem[] {
  return [
    {
      title: msg("Release Cycles"),
      url: "/release-management/cycles",
      icon: "calendar-days",
    },
    {
      title: msg("Releases"),
      url: "/release-management/releases",
      icon: "tag",
    },
    {
      title: msg("Deployments"),
      url: "/release-management/deployments",
      icon: "rocket",
    },
    {
      title: msg("Approvals"),
      url: "/release-management/approvals",
      icon: "shield-check",
    },
  ];
}
